import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

/**
 * Resolves the active `date-fns` locale for the user's selected language by
 * dynamically importing the locale module. Keeps the ~35 locale files out of
 * the main bundle — they ship in their own chunk loaded on first use.
 * @returns {import('date-fns').Locale|null} the resolved locale, or `null` while loading.
 */
export function useDateLocale () {
  const selectedLanguageCode = useSelector((state) => state.language.selectedLanguageCode)
  const [dateLocale, setDateLocale] = useState(null)

  useEffect(() => {
    let cancelled = false
    import('utils/dateLocale').then(({ getDateLocale }) => {
      if (!cancelled) setDateLocale(getDateLocale(selectedLanguageCode))
    })
    return () => { cancelled = true }
  }, [selectedLanguageCode])

  return dateLocale
}
